// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"48a6dc06","239":"b335ad1b","453":"bc24b13e","455":"d162731d"}[chunkId] + ".chunk.js";
};